import { SeoRenderer } from "../../../common/helpers/seo";
import loadable from "./loadable";

export default {
    component: loadable,
    renderSeo: (store, allMessage, lang) => {
        SeoRenderer({ title: "Translate", allMessage, lang, type: "article" });
    },
};
